import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A7OPCVMIssuersEdit } from "./edit";
import { A7OPCVMIssuersTable } from "./table";

export default function A7OPCVMIssuers() {
  useEffect(() => {
    setDocumentTitle("Quantilia | OPCVM Émetteurs");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A7OPCVMIssuersEdit />} />
      <Route index element={<A7OPCVMIssuersTable />} />
    </Routes>
  );
}
